module.exports = __webpack_public_path__ + "img/M240_F_AGBWA_001_2048x2048.4efd7242.png";